import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";

import { FullFormState } from "../Engine/src/Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../Engine/src/Engine/Core/Store/CandyReduxTypes";

export const useTypedSelector: TypedUseSelectorHook<FullFormState> = useSelector;

export const useTypedDispatch: () => CandyDispatch = useDispatch;
